<div class="notes-container">
    <div class="header-container">
        <div>
            <span class="t7 bold patient-name">{{patientName}}</span>
            <span class="badge badge-pill badge-primary">{{ patientRoom }}</span>
            <span class="badge badge-pill badge-primary ml-3">{{ patientBed
            }}</span>
        </div>
        <div class="col-2">
            <button class="btn
            btn-primary btn-block" (click)="createNote()">
                Create
            </button>
        </div>
    </div>
    <div class="sor-status-type-container">
        <div class="status-type-item">
            <mat-icon class="status-icon" svgIcon="check-circle"></mat-icon>
            <span class="t5 bold status-item-text">Successfully sent to SAP</span>
        </div>
        <div class="status-type-item">
            <mat-icon class="status-icon" svgIcon="test"></mat-icon>
            <span class="t5 bold status-item-text">Sending to SAP</span>
        </div>
        <div class="status-type-item">
            <mat-icon class="status-icon" svgIcon="cross-circle"></mat-icon>
            <span class="t5 bold status-item-text">Sending to SAP failed</span>
        </div>
    </div>
    <div class="note-list-container">
        <div class="note" *ngFor="let patientNote of offlinePatientNotes">
            <app-note-card-item [patientNote]="patientNote">
            </app-note-card-item>
        </div>
    </div>
    <div *ngIf="patientNotes.length === 0 " class="d-flex justify-content-center
    align-items-center patient-basket-empty">
        <div class="d-flex flex-column text-center">
            <div class="empty-list">
                <mat-icon svgIcon="patient-summary" class="align-self-center"></mat-icon>
            </div>
            <div class="patient-basket-empty-text-header">
                No notes have been created
            </div>
            <div class="patient-basket-empty-text-sub text-muted">
                Click create note to create a new note
            </div>
        </div>
    </div>
</div>